import axios from "../api";


export const createPlanFeatureAction = (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/plan-feature/create", data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getPlanFeatureListAction = (params) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/plan-feature/list", {
                params,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};


export const getPlanFeatureByIdAction = (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/plan-feature/${id}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updatePlanFeatureAction = (id, data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/plan-feature/update/${id}`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};


export const deletePlanFeatureAction = (id) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(`/api/plan-feature/delete/${id}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};